import styled from 'styled-components';

export const VerifyOTPStyled = styled.div`
  border-radius: 16px;
  width: 100%;
  max-width: 350px;
  padding: 18px 12px;
  background: ${({ theme }) => theme.COLORS.WHITE_2};
`;
